import type { DisplayJob } from '../types';
import type { JobFormState } from '../redux/features/jobFormSlice';
import type { ComparisonPreferencesState } from '../redux/features/comparisonPreferencesSlice';
import type { SearchEntry } from '../redux/features/savedSearchesSlice';
import type { ResolvedJobMatch } from '../../types/job-match';
import { calculateJobMatchScore } from '../data/calculate-job-match-score';
import { inferJobMatchFromRecentSearches } from './infer-job-match-from-recent-searches';

export function resolveJobMatchScore(params: {
  job: DisplayJob;
  userProfile: JobFormState;
  comparisonPreferences: ComparisonPreferencesState;
  savedSearches: SearchEntry[];
  isHydrated: boolean;
}): ResolvedJobMatch {
  const { job, userProfile, comparisonPreferences, savedSearches, isHydrated } = params;
  if (!isHydrated) {
    return { breakdown: null, source: null, searchInferenceBullets: [] };
  }

  const profile = calculateJobMatchScore(job, userProfile, comparisonPreferences);
  if (profile !== null) {
    return { breakdown: profile, source: 'profile', searchInferenceBullets: [] };
  }

  const inferred = inferJobMatchFromRecentSearches(job, savedSearches, comparisonPreferences);
  if (inferred !== null) {
    return {
      breakdown: inferred.breakdown,
      source: 'recent-searches',
      searchInferenceBullets: inferred.bullets,
    };
  }

  return { breakdown: null, source: null, searchInferenceBullets: [] };
}
